import Select, { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import React, { useEffect, useState } from "react";
import { count, list } from "sources/books/legalPersons";

export default function LegalPersonFilter(props) {
    const [legalPersonCount, setLegalPersonCount] = useState(0);
    useEffect(() => {
        count().then((res) => setLegalPersonCount(res.count || 0));
    }, []);
    if (legalPersonCount < 2) {
        return null;
    }
    const selectProps = {
        ...defaultMultipleSelectProps,
        components: { ValueContainer },
        inputProps: { name: "legalPersonId" },
        value: props.values.legalPersonId || undefined,
        placeholder: "Организация",
        url: list,
        propName: "name",
        onChange: props.setFilter,
        className: "report__filters--control",
        styles: {
            control: (styles) => ({ ...styles, minHeight: "31px", fontSize: "14px" }),
            indicatorsContainer: (styles) => ({ ...styles, height: "29px" }),
        },
    };
    return (
        <div className="mb-md-0 report__filters--mr">
            <Select {...selectProps} />
        </div>
    );
}
